/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import Toast from 'react-native-toast-message';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import ModalUpload from '@components/modal/ModalUpload';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import { MsB2b } from '@api/ms-b2b';
import importTemplate from '@/assets/csv/template-import-promotion-accounts';

const PromotionAccountCreateOption = (props) => {
  const dispatch = useDispatch();
  const visible = useSelector(
    (state) => state.modal.promotionAccountCreateOption,
  );
  const showImportModal = useSelector(
    (state) => state.modal.showImportModalPromotionAccounts,
  );

  const onClose = () => {
    dispatch(showPopup({ name: 'promotionAccountCreateOption', value: false }));
  };

  const handleAddManually = () => {
    onClose();
    setTimeout(() => {
      // Prefer openChild so the list's search + pagination are preserved on
      // return; fall back to a plain navigate when it isn't provided.
      if (props.openChild) {
        props.openChild('PromotionAccountFormScreen');
      } else {
        props.navigation.navigate('PromotionAccountFormScreen');
      }
    }, 250);
  };

  const handleImportCSV = () => {
    onClose();
    setTimeout(() => {
      dispatch(
        showPopup({ name: 'showImportModalPromotionAccounts', value: true }),
      );
    }, 250);
  };

  const handleImport = async (url) => {
    try {
      dispatch(
        showPopup({ name: 'showImportModalPromotionAccounts', value: false }),
      );
      const response = await MsB2b.importPromotionAccounts({ url });
      if (response.status === 200) {
        Toast.show({
          text1: 'Import Promotion Account In Progress',
          type: 'success',
        });
        if (props.onImportSuccess) {
          props.onImportSuccess();
        }
      } else {
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  return (
    <View>
      <ModalTopRounded
        title="Add Promotion Account"
        visible={visible}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={onClose}>
        <View style={styles.promotionCreate}>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleAddManually}>
            <Image
              style={{ width: 43, height: 43 }}
              width={43}
              height={43}
              source={require('@assets/img/icons/add-manually.png')}
            />
            <SociollaText style={styles.itemText}>Add Manually</SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleImportCSV}>
            <Image
              style={{ width: 35, height: 43 }}
              width={35}
              height={43}
              source={require('@assets/img/icons/import-csv.svg')}
              svg={true}
            />
            <SociollaText style={styles.itemText}>Import CSV</SociollaText>
          </TouchableOpacity>
        </View>
      </ModalTopRounded>
      {showImportModal ? (
        <ModalUpload
          show={showImportModal}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalPromotionAccounts',
                value: false,
              }),
            )
          }
          templateUrl={importTemplate}
          onUpload={handleImport}
          autoUploadS3={true}
          name="import_promotion_accounts"
          validHeader={[
            'account_group',
            'promotion_name',
            'start_period',
            'end_period',
            'reference',
          ]}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  promotionCreate: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

export default PromotionAccountCreateOption;
